import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
// Loaded after `/design-system/styles.css` (linked in index.html):
// tokens.css only aliases GizzAI tokens, ui.css only styles the parts the
// design system does not ship.
import "@xinghai/ui/tokens.css";
import "@xinghai/ui/ui.css";
import "./app.css";
import { Providers } from "./app/providers";
import { ErrorBoundary } from "./app/ErrorBoundary";
import { createRouter } from "./app/router";

const el = document.getElementById("root");
if (!el) throw new Error("#root not found");

createRoot(el).render(
  <StrictMode>
    <ErrorBoundary>
      <Providers>
        <RouterProvider router={createRouter()} />
      </Providers>
    </ErrorBoundary>
  </StrictMode>,
);
